const INITIAL_STATE = {
  data: {
    groups: [],
    users: [],
    events: [],
    recordings: []
  },
  isFetching: false,
  error: false,
  errorContent: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'REPORT_CONTENTS_START_REQUEST':
      return {
        ...state,
        isFetching: true,
        errorContent: ''
      };
    case 'REPORT_CONTENTS_END_REQUEST':
      return {
        ...state,
        isFetching: false
      };
    case 'REPORT_CONTENTS_SUCCESS':
      return {
        ...state,
        data: { ...state.data, [payload.type]: payload.data }
      };
    case 'REPORT_CONTENTS_ERROR':
      return {
        ...state,
        error: true,
        errorContent: payload,
        data: { ...state.data, [payload.type]: [] }
      };
    case 'REPORT_CONTENTS_DEFAULT':
      return {
        ...state,
        data: { ...state.data, [payload.type]: [] }
      };
    default:
      return { ...state };
  }
};

export default reducer;
